import $ from "jquery";

$.nette.ext('search', {
	init: function() {
		this.$form = $('.form-search');
		this.search = this.$form.Search();
		this.$results = $('.search .search-results');
	},

	success: function(payload) {
		const snippets = payload.snippets;
		if (!snippets) return;
		const results = snippets['snippet--search'];

		if (results && results.trim() !== '') {
			this.$results.html(results);
			this.$form.Search('dataLoaded');
		}
	}
}, {
	$results: null,
	close: function() {
		this.$form.Search('close');
	}
	// ... shared context (this) of all callbacks
});
